// @ts-strict-ignore
import { Component } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";
import { ChannelAddress } from "src/app/shared/shared";

@Component({
  templateUrl: "./modal.html",
})
export class ModalComponent extends AbstractModal {

  public meterActivePowerChannelAddress: ChannelAddress;
  public essSocChannelAddress: ChannelAddress;
  public peakShavingPowerChannelAddress: ChannelAddress;
  public rechargePowerChannelAddress: ChannelAddress;

  protected override getChannelAddresses(): ChannelAddress[] {
    this.meterActivePowerChannelAddress = new ChannelAddress(this.component.properties["meter.id"], "ActivePower");
    this.essSocChannelAddress = new ChannelAddress(this.component.properties["ess.id"], "Soc");
    this.peakShavingPowerChannelAddress = new ChannelAddress(this.component.id, "_PropertyPeakShavingPower");
    this.rechargePowerChannelAddress = new ChannelAddress(this.component.id, "_PropertyMaxGridPowerDuringRecharge");

    return [
      this.meterActivePowerChannelAddress,
      this.essSocChannelAddress,
      this.peakShavingPowerChannelAddress,
      this.rechargePowerChannelAddress,
    ];
  }

  protected override getFormGroup(): FormGroup {
    return this.formBuilder.group({
      peakShavingPower: new FormControl(this.component.properties["peakShavingPower"], Validators.compose([
        Validators.pattern("^(?:[1-9][0-9]*|0)$"),
        Validators.required,
      ])),
      maxGridPowerDuringRecharge: new FormControl(this.component.properties["maxGridPowerDuringRecharge"], Validators.compose([
        Validators.pattern("^(?:[1-9][0-9]*|0)$"),
        Validators.required,
      ])),
      minSocLimit: new FormControl(this.component.properties["minSocLimit"]),
    }, { validators: this.peakShavingPowerRelationValidator() });
  }

  /** peakShavingPower must not be below maxGridPowerDuringRecharge. */
  private peakShavingPowerRelationValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const peakShavingPower = group.get("peakShavingPower")?.value;
      const maxGridPowerDuringRecharge = group.get("maxGridPowerDuringRecharge")?.value;

      if (peakShavingPower == null || peakShavingPower === ""
        || maxGridPowerDuringRecharge == null || maxGridPowerDuringRecharge === "") {
        return null; // handled by Validators.required
      }

      return Number(peakShavingPower) >= Number(maxGridPowerDuringRecharge)
        ? null
        : { message: this.translate.instant("Edge.Index.Widgets.Peakshaving.relationError") };
    };
  }
}
